// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__MG0Gf","Avatar__person":"Avatar_Avatar__person__sIlP-","Avatar__award":"Avatar_Avatar__award__14KyU"};